/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../services/googleAnalyticsService";

const CookiePolicyPageMeta = () => {
  const title = "Cookierichtlinie Legalbird Rechtsanwälte Rechtsanwalts GmbH | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Lesen Sie hier die Cookierichtlinie der Legalbird Rechtsanwälte Rechtsanwalts GmbH" />
      <meta name="keywords" content="Cookies, Datenschutz, Datenschutzbestimmungen, DSGVO, PrivacyLawFirm" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Lesen Sie hier die Cookierichtlinie der Legalbird Rechtsanwälte Rechtsanwalts GmbH" />
    </Helmet>
  );
};

export default CookiePolicyPageMeta;
